export const CARGOS_POR_AREA = {
  ADMINISTRACION: {
    ADMINISTRADOR: 1,
  },

  FINANZAS: {
    GERENTE: 2,
    JEFE_AREA: 3,
    SUPERVISOR: 4,
    FUNCIONARIO: 5,
    COORDINADOR: 47,
  },

  CONTROL: {
    JEFE_AREA: 6,
    ANALISTA: 7,
    FUNCIONARIO: 8,
  },

  GN: {
    JEFE_AREA: 9,
    COORDINADOR: 10,
    FUNCIONARIO: 11,
    SUBGERENTE: 53,
  },

  DO: {
    JEFE_AREA: 12,
    SUBGERENTE: 13,
    COORDINADOR: 14,
    FUNCIONARIO: 15,
  },

  COMUNICACIONES: {
    JEFE_AREA: 16,
    SUBGERENTE: 17,
    FUNCIONARIO: 18,
  },

  INNOVACION: {
    JEFE_AREA: 19,
    SUBGERENTE: 20,
    FUNCIONARIO: 21,
  },

  DSP: {
    JEFE_AREA: 22,
    SUBGERENTE: 23,
    COORDINADOR: 24,
    FUNCIONARIO: 25,
  },

  DATA: {
    JEFE_AREA: 26,
    SUBGERENTE: 27,
    LIDER_TECH: 28,
    FUNCIONARIO: 29,
    GERENTE: 48,
  },

  PERSONAS: {
    JEFE_AREA: 30,
    SUBGERENTE: 31,
    BUSINESS_PARTNER: 32,
    FUNCIONARIO: 33,
  },

  SERVICIOS: {
    JEFE_AREA: 37,
    SUBGERENTE: 38,
    ASISTENTE: 39,
    FUNCIONARIO: 40,
  },

  COMERCIAL: {
    SUBGERENTE: 60,
    AGENTE_SUR: 54,
    AGENTE_METRO: 55,
    AGENTE_NORTE: 56,
    EJECUTIVO: 57,
    ASISTENTE: 58,
    JEFE_OFICINA: 59,
  },
} as const;